import React from 'react';
import { Helmet } from 'react-helmet-async';
import html2pdf from 'html2pdf.js';
import { sendGAPageview } from '../utils/gaConsent';
import LegalContentFromMarkdown from '../components/Legal/LegalContentFromMarkdown';
import $ from 'jquery';
import { PrinterIcon } from '@heroicons/react/24/solid';

const LegalNotices = () => {
  $('.popover').hide();
  sendGAPageview({ hitType: 'pageview', page: '/Legal', title: 'Legal Notices' });

  const downloadSummary = () => {
    const element = document.getElementById('printer');
    if (!element) return;
    element.classList.add('pdf-mode');
    
    const opt = {
      margin: [20, 40, 40, 20] as [number, number, number, number],
      filename: 'legal.pdf',
      image: { type: 'jpeg' as 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: { unit: 'pt', format: 'a4', orientation: 'portrait' as 'portrait' },
      pagebreak: {
        mode: ['avoid-all', 'css', 'legacy'],
      },
    };
    
    html2pdf()
      .set(opt)
      .from(element)
      .save()
      .then(() => {
        element.classList.remove('pdf-mode');
      });
  };

  return (
    <React.Fragment>
      <Helmet>
        <title>DISGENET: Legal Notices</title>
        <meta
          name="description"
          content="Explore DISGENET's legal notices, stay informed about your rights and responsibilities when using our platform."
        />

        {/* Open Graph Tags for LinkedIn */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.disgenet.com/Legal" />
        <meta property="og:title" content="DISGENET: Legal Notices" />
        <meta
          property="og:description"
          content="Learn about the legal notices, terms, and conditions for using DISGENET, ensuring that you're informed about your rights and responsibilities."
        />
      </Helmet>
      <section>
        <link rel="canonical" href="/Legal" />
        <div className="container txt-contenido mr-20 text-right">
          <button
            className="btn bg-light rounded-circle mr-12"
            onClick={downloadSummary}
            title="Download PDF"
          >
            <PrinterIcon className="w-4 h-4" />
          </button>
        </div>
        <div className="container txt-contenido" id="printer">
          <LegalContentFromMarkdown />
        </div>
      </section>
    </React.Fragment>
  );
};

export default LegalNotices;
